import { GetterTree } from 'vuex';
import { DialogState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<DialogState, RootState> = {
  show(state): boolean {
    return state.show;
  },
  cancel(state): boolean {
    return state.cancel;
  },
  message(state): string {
    const { message } = state;
    return `${message}`;
  },
  callbackFn(state): Function|null {
    const { callbackFn } = state;
    return callbackFn;
  },
  cancelCallbackFn(state): Function|null {
    const { cancelCallbackFn } = state;
    return cancelCallbackFn;
  }
};
